import { type JSX } from "react";
import Link from "next/link";
import { Body, H2, H4 } from "../Typography"
import {
    MarketingCenteredTextContainer,
    MarketingCenteredTextWrapper,
    DesktopIconWrapper,
    PunchlineWrapper,
    CenteredTextLinkWrapper
} from "./MarketingCenteredText.styles"
import { MarketingDashSubtitle } from "../MarketingDashSubtitle";

type MarketingCenteredTextProps = {
    title: string,
    punchline?: JSX.Element,
    description: JSX.Element,
    linkText?: JSX.Element,
    href?: string,
    desktopIcon?: JSX.Element,
    mobileIcon?: JSX.Element,
    iconPosition?: "left" | "right"
}

export const MarketingCenteredText = ({ title, punchline, description, href, linkText, desktopIcon, mobileIcon, iconPosition = "left" }: MarketingCenteredTextProps) => {
    return <MarketingCenteredTextWrapper>
        <MarketingCenteredTextContainer>
            {!!title && <MarketingDashSubtitle subtitle={title} />}
            {
                punchline && <PunchlineWrapper>
                    <div>
                        <H2 as="h2">{punchline}</H2>
                    </div>
                    <div>
                        {mobileIcon}
                    </div>
                </PunchlineWrapper>
            }
            <Body>
                {description}
            </Body>
            {
                linkText && <CenteredTextLinkWrapper>
                    <Link href={href || "#"} passHref>
                        <div>
                            <div>
                                <H4>{linkText}</H4>
                            </div>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 4L10.7012 9.32613C11.0996 9.6983 11.0996 10.3017 10.7012 10.6739L5 16" stroke="#2E77FF" />
                            </svg>
                        </div>
                    </Link>
                </CenteredTextLinkWrapper>
            }
        </MarketingCenteredTextContainer>
        {
            desktopIcon && <DesktopIconWrapper iconPosition={iconPosition} >
                {desktopIcon}
            </DesktopIconWrapper>
        }
    </MarketingCenteredTextWrapper>
}